import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { CALYPSO } from 'HubStyleTokens/colors';
import { useState } from 'react';
import styled from 'styled-components';
import UICardHeader from 'UIComponents/card/UICardHeader';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import AccordionTransition from 'UIComponents/transitions/AccordionTransition';
import { useAppSelector } from '../../../reducers';
import { skuIdIsAddonOrServiceSelector } from '../../../selectors/ProductsSelectors';
import { StyledTitleContainer } from '../SharedComponents';
import ExpandableChecklistItem from './ExpandableChecklistItem';
const TextContainer = styled.div.withConfig({
  displayName: "ExpandableChecklist__TextContainer",
  componentId: "jdsrcp-0"
})(["&:hover{cursor:pointer;}"]);
const Container = styled(UICardWrapper).withConfig({
  displayName: "ExpandableChecklist__Container",
  componentId: "jdsrcp-1"
})(["max-width:700px;"]);
const StyledCardHeader = styled(UICardHeader).withConfig({
  displayName: "ExpandableChecklist__StyledCardHeader",
  componentId: "jdsrcp-2"
})(["& > div > span{width:inherit;}"]);
const CardSection = styled(UICardSection).withConfig({
  displayName: "ExpandableChecklist__CardSection",
  componentId: "jdsrcp-3"
})(["padding-bottom:12px;&:last-child{padding-bottom:40px;}"]);
const ContentSection = styled.div.withConfig({
  displayName: "ExpandableChecklist__ContentSection",
  componentId: "jdsrcp-4"
})(["padding-bottom:12px;&:last-child{padding-bottom:40px;}"]);
const StyledHeaderContainer = styled.div.withConfig({
  displayName: "ExpandableChecklist__StyledHeaderContainer",
  componentId: "jdsrcp-5"
})(["margin-top:12px;"]);

const ExpandableChecklist = ({
  title,
  subtext,
  skuIds = [],
  selectedProductConfigurations,
  onSelectedChange,
  use,
  defaultOpen,
  trackAccordionInteraction,
  queryParamTerm,
  compact = false
}) => {
  const hasSelectedMerch = useAppSelector(state => selectedProductConfigurations.filter(({
    skuId
  }) => skuIdIsAddonOrServiceSelector(state, {
    skuId
  })).length > 0);
  const [isOpen, setIsOpen] = useState(defaultOpen || hasSelectedMerch);
  const iconName = isOpen ? 'minus' : 'add';

  const toggleAccordion = () => {
    const newAccordionState = !isOpen;
    setIsOpen(newAccordionState);
    trackAccordionInteraction(use, newAccordionState);
  };

  const Wrapper = compact ? 'div' : Container;
  const SectionContainer = compact ? ContentSection : CardSection;

  const ChecklistTitle = /*#__PURE__*/_jsxs(TextContainer, {
    onClick: toggleAccordion,
    "data-selenium-id": `plan-builder-${use}-checklist-toggle`,
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      direction: "row",
      justify: "between",
      children: [/*#__PURE__*/_jsx(StyledTitleContainer, {
        children: title
      }), /*#__PURE__*/_jsx(UIIcon, {
        color: CALYPSO,
        name: iconName,
        size: "medium"
      })]
    }), subtext]
  });

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Wrapper, {
      children: [compact ? /*#__PURE__*/_jsx(StyledHeaderContainer, {
        children: ChecklistTitle
      }) : /*#__PURE__*/_jsx(StyledCardHeader, {
        titleSize: "xs",
        title: ChecklistTitle
      }), /*#__PURE__*/_jsx(AccordionTransition, {
        open: isOpen,
        "data-selenium-id": `plan-builder-${use}-checklist`,
        children: skuIds.map(skuId => {
          const selectedProductConfiguration = selectedProductConfigurations.find(({
            skuId: searchSkuId
          }) => searchSkuId === skuId);
          return /*#__PURE__*/_jsx(SectionContainer, {
            children: /*#__PURE__*/_jsx(ExpandableChecklistItem, {
              skuId: skuId,
              selectedQuantity: selectedProductConfiguration && selectedProductConfiguration.quantity || 0,
              onSelectedChange: onSelectedChange,
              use: use,
              queryParamTerm: queryParamTerm
            })
          }, skuId);
        })
      })]
    })
  });
};

export default ExpandableChecklist;